module.exports = __webpack_public_path__ + "static/media/ApplicationPageLink.2034a0cd.svg";